import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

/**
 * Marks a platform-estimated invoice (see `CreditCardInvoice.isEstimated`).
 * Dashed outline reads as "provisional" next to the solid status badge.
 */
export function EstimateBadge({ className }: { className?: string }) {
  return (
    <Badge
      size="sm"
      variant="outline"
      className={cn('border-dashed', className)}
      title="Fatura estimada pela Vértice — o banco ainda não enviou a fatura fechada"
    >
      Estimada
    </Badge>
  );
}
